import { useQuery } from "@tanstack/react-query";
import { fetchAllEvents } from "../api/match_events";
import { MatchEventType } from "../directus/collections";
import { useStatsQuery } from "../extensions/sw/modules/stats/hooks";
import { StatsQuery } from "../extensions/sw/modules/stats/types";
import { MatchFilter } from "../libs/statsFilters";
import { useDirectus } from "../providers/DirectusProvider";
import { WorkerQueryOptions } from "../libs/workers/types";

export const useMatchEvents = ({
  matchId,
  targetId,
  options,
}: {
  matchId: string;
  targetId?: string;
  options?: { enabled: boolean };
}) => {
  const { client } = useDirectus();
  const props: Record<string, any> = { matchId };
  if (targetId) props.targetId = targetId;

  return useQuery({
    queryKey: ["events", "enigma", matchId],
    queryFn: () =>
      fetchAllEvents(client, {
        ...props,
        sort: ["date_created"],
      }),
    enabled: !!matchId && options?.enabled !== false,
  });
};

export function useAvgTimeToEvent(
  { eventType, value }: { eventType: MatchEventType; value?: string },
  cityEscapeId?: string,
  targetId?: string,
  filters?: Record<string, any>,
  opts?: WorkerQueryOptions
) {
  return useStatsQuery({
    type: StatsQuery.AVG_TIME_TO_EVENT,
    data: { cityEscapeId, targetId, eventType, value, filters },
    opts: { ...opts, traceKey: opts?.traceKey ?? "useAvgTimeToEvent" }
  });
}

export function useTotalWithdrawalsEvent({
  cityEscapeIds,
  filters,
  opts,
}: {
  cityEscapeIds: string | string[] | null;
  filters?: MatchFilter;
  opts?: WorkerQueryOptions;
}) {
  return useStatsQuery({
    type: StatsQuery.TOTAL_WITHDRAWALS_EVENTS,
    data: { cityEscapeIds, filters },
    opts: { ...opts, traceKey: opts?.traceKey ?? "useTotalWithdrawalsEvent" }
  });
}
